import reference from '../../assets/images/IMG_4524.webp';
import './Reference.scss';

export const Reference = () => {
    return (
        <section className="reference">
            <div className="container">
                <div className="reference__wrapp">
                    <h4>Рекомендации</h4>
                    <div className="reference__wrapp-info">
                        
                        <div className='reference-img'>
                            <div className='back-reference-img'></div>
                            <img src={reference} alt="reference" />
                        </div>
                       
                        <span>Мы гордимся тем, что можем предложить вам наши ресурсы, высокое качество услуг и внимание к деталям.</span>
                    </div>
                </div>
            </div>
        </section>
    )
}